import { ComponentType } from 'react'
import { Badge } from 'reactstrap'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

const Wrapper = styled.div`
  padding-bottom: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${up('sm')} {
    padding-bottom: 24px;
  }
`

interface Props {
  property: any
}

export const Badges: ComponentType<Props> = ({ property }) => (
  <Wrapper>
    <div className="mx-n4px">
      {property.role.includes('sale') && (
        <Badge color="primary" className="mx-4px px-15 py-8 rounded-md">
          <span className="text-white text-uppercase font-size-12">En venta</span>
        </Badge>
      )}
      {property.role.includes('rent') && (
        <Badge color="success" className="mx-4px px-15 py-8 rounded-md">
          <span className="text-white text-uppercase font-size-12">En renta</span>
        </Badge>
      )}
    </div>
    <div className="text-primary font-size-14">{property.uuid}</div>
  </Wrapper>
)